import { createDispatchHook, createSelectorHook } from "react-redux";
import { ContextStore, store } from "./store";

export const useAppDispatchJS = createDispatchHook(ContextStore)
export const useAppSelectorJS = createSelectorHook(ContextStore)